
<mat-card appearance="outlined" class="teste form-field-density-4">
  <mat-card-header>
    <mat-card-title>
      <div class="view-component-title">
        <span class="title">Importação de Dados</span>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="config-container">     
      <search-input class="search-input-dados" [loaddesc]="true" ignoreDefCondition="false" entityname="Mktpdic" [form]="firstFormGroup"  [condition]="conditionSearch" entitydesc="Mktpdic" controlname="IDINSTANCE" placeholder="Tabela" fieldname="INSTANCENAME" columnname="IDINSTANCE" class="no-padding-form-field"  >
      </search-input>
    
      <div class="container-label form-field-density-4">     
        <mat-form-field *ngIf="uas.user.companylist.length > 1 ">
          <mat-label>Escolher uma Empresa</mat-label>
          <mat-select [disabled]="disabled" [(ngModel)]="codecompany" (selectionChange)="getActiveCompanies()">
              <mat-option *ngFor="let data of uas.user.companylist" [value]="data.codecompany">
                  {{data.codecompany}} - {{data.companyname}}
              </mat-option>
          </mat-select>
          </mat-form-field>
        <div class="margin-top10">
          <!--button mat-raised-button color="primary" class="button-margin my-button-class" (click)="openJsonDPARAModal()">
            <mat-icon>settings</mat-icon> Configurar JSON
          </button-->
          <button mat-raised-button color="primary" class="button-margin my-button-class" (click)="openDPARAModal()">
            <mat-icon>settings</mat-icon> Configurar D-PARA
          </button>
          <button mat-raised-button color="primary" class="button-margin my-button-class" (click)="downloadTemplate()">
            <mat-icon>get_app</mat-icon> Baixar Modelo
          </button>
          <button mat-raised-button color="primary" class="button-margin my-button-class" (click)="downloadTable()">
            <mat-icon>get_app</mat-icon> Download Tabela
          </button>        
          <input type="file" (change)="uploadFile($event)" style="display: none" #fileInput>
          <button mat-raised-button color="primary" class="my-button-class" (click)="fileInput.click()">
            <mat-icon>cloud_upload</mat-icon> Upload de Arquivo
          </button>
          <mat-slide-toggle class="toogleTest" [(ngModel)]="isTestMode" color="primary" matTooltip="Ative para modo de teste. As importações não serão salvas no banco.">
            Modo Teste
          </mat-slide-toggle>
        </div>     
      </div>
      <div class="config-info">
        <div class="config-label">Configuração:</div>
        <div class="config-values">{{ configId }}</div>
        <div class="config-separator">-</div>
        <div class="config-values">{{ tableName }}</div>
      </div>    
    </div>
    
  </mat-card-content>
</mat-card>

<div class="view-component"> 
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" ngClass="custom-tabs combined-tab" (selectedTabChange)="onTabChanged($event);">
      <mat-tab id="Mktpuserimportcfg"> 
          <ng-template mat-tab-label>
              Configurações
          </ng-template>
          <div class="content">         
            <simple-datagrid #datagridCfg entityName="Mktpuserimportcfg" [parentRow]="parentRow" [selectedRow]="selecteRow" [condition]="conditionCfg" [getCondition]="getConditionFunction" [events]="eventsSubject.asObservable()"></simple-datagrid>
          </div>                    
      </mat-tab>
     <mat-tab id="ImportacaoLinhasImportadas"> 
      <ng-template mat-tab-label>
        Arquivo Importado | Linhas Importadas
      </ng-template>
      <div class="content">
        <div class="view-component-tab">
          <div class="content-tab">
            <simple-datagrid #datagridImp entityName="Mktpuserimport" [parentRow]="parentRow" [selectedRow]="selecteRowImp" [condition]="conditionImp" [getCondition]="getConditionImpFunction" nodata="true" [events]="eventsSubject.asObservable()"></simple-datagrid>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="content-tab">            
            <simple-datagrid #datagridImpLog entityName="Mktpuserimportlog" [parentRow]="parentRow" [condition]="conditionImpLog" nodata="true" [getCondition]="getConditionLogFunction" [events]="eventsSubject.asObservable()"></simple-datagrid>
          </div>
        </div>        
      </div>                 
    </mat-tab>
    </mat-tab-group>    
</div> 


